<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="closeModalWithCancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp_FILL0_wght400_GRAD0_opsz24.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Libreta de direcciones</ion-title>
  </ion-toolbar>

  <ion-toolbar>
    <form [formGroup]="formAddressEdit">
      <ion-grid class="">
        <ion-row>
          <ion-col size="12">
            <ion-input
              #searchInput
              type="text"
              label="Término a buscar"
              formControlName="searchTerm"
              (ionInput)="handleChangeTerm($event)"
              debounce="300"
              placeholder="Nombre, parte de la dirección,..."
              labelPlacement="floating"
              fill="outline"
              mode="md"
              clearInput
            ></ion-input>
          </ion-col>
        </ion-row>
      </ion-grid>
    </form>
  </ion-toolbar>
</ion-header>

<ion-content class="">
  @if (isLoading()) {
    <lib-spinner-loading></lib-spinner-loading>
  } @else {
    @for (addressbookEntry of addressbookEntries(); track $index) {
      <ion-item
        button="true"
        (click)="handleSelectAddress(addressbookEntry)"
      >
        <ion-label>
          @if (addressbookEntry.company) {
            <p>
              <strong>{{ addressbookEntry?.company }}</strong>
            </p>
          }
          <p>{{ addressbookEntry.textToDisplay }}</p>
        </ion-label>
      </ion-item>
    } @empty {
      <ion-item>
        <ion-label>
          <p class="ion-text-center">No hay resultados. Cambie los términos de búsqueda.</p>
        </ion-label>
      </ion-item>
    }
  }
</ion-content>
